(function authNotificationConfigControllerDefinition() {
    'use strict';

    angular.module('AuthNotificationConfig')
        .controller('AuthNotificationConfigAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', '$filter', 'adminAuthNotificationConfigService', 'notificationService', 'functionService', 'fileService',
            function AuthNotificationConfigAddController($scope, config, $state, $translate, errors, authExtend, $filter, adminAuthNotificationConfigService, notificationService, functionService, fileService) {
                $scope.load = function () {
                    $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');
                    $scope.aux = {
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizatioanlUnitName: authExtend.getOrganizationName(),
                        name: null,
                        templateId: null,
                        templateName: null,
                        templateData: [],
                        metadatas: [],
                        applicationId: config.appId(),
                        ForApp: { Id: 1, Name: 'Easy Doc Repository'},
                        files: [],
                        filesTemp: [],
                        title: "",
                        body: "",
                        sendMail: false,
                        needsSignature: false,
                        isBodyText: true,
                        selectedFile: undefined
                    };
                    if ($scope.allApps) {
                        functionService.getApps().then(function getOk(result) {
                            $scope.optionApps = $filter('filter')(result, function (app) {
                                // Filtro solo por EDR y Arándanos
                                return app.id === 1 || app.id === 4;
                            });
                            $scope.app = $scope.optionApps.find(function (item) { return item.id === 1; });
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                    
                    notificationService.getTemplates('AUTH').then(function (result) {
                        $scope.selectTemplate($filter('filter')(result, { id: "2" }, true)[0]);
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go('auth-notification-config-find');
                };

                $scope.selectApp = function (app) {
                    $scope.aux.ForApp.Id = app.id;
                    $scope.aux.ForApp.Name = app.name;    

                    // Para EDR no dejo que se puedan elejir estas opciones
                    if ($scope.aux.ForApp.Id === 1) {
                        $scope.aux.isBodyText = true;
                        $scope.aux.needsSignature = false;
                    }
                };

                $scope.selectTemplate = function (item) {
                    if (item.id !== $scope.aux.templateId) {
                        $scope.aux.templateId = item.id;
                        $scope.aux.templateName = item.name;
                        $scope.aux.TemplateisUniqueConfig = item.isUniqueConfig;
                    }
                };

                $scope.addFile = function () {
                    if ($scope.aux.filesTemp && $scope.aux.filesTemp.size) {
                        var extension = $scope.aux.filesTemp.name.substr($scope.aux.filesTemp.name.lastIndexOf('.') + 1);

                        if (extension !== 'pdf') {
                            errors.showError('FilePdfExtensionError');
                            return;
                        }
                        $scope.aux.files = [];
                        $scope.aux.filesTemp.fsize = fileService.FormatfileSize($scope.aux.filesTemp.size);
                        $scope.aux.files.push($scope.aux.filesTemp);
                    }

                    $scope.aux.filesTemp = [];
                    $scope.aux.selectedFile = $scope.aux.files[0];
                };

                $scope.removeFile = function () {
                    $scope.aux.files = [];
                    $scope.aux.selectedFile = undefined;
                };

                $scope.getIndexFile = function (fileNew) {
                    for (var i in $scope.aux.files) {
                        if ($scope.aux.files.hasOwnProperty(i)) {
                            var fileOld = $scope.aux.files[i];

                            if (fileOld.name === fileNew.name) {
                                return i;
                            }
                        }
                    }
                    return -1;
                };

                $scope.save = function () {
                    if (!$scope.notificationsForm.$valid) {
                        $scope.notificationsForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return;
                    }

                    if (!$scope.aux.isBodyText && $scope.aux.files && $scope.aux.files.length <= 0) {
                        errors.showError('VerifyFormOneFile');
                        return;
                    }

                    $scope.aux.datas = [];
                    var files = [];

                    if (!$scope.aux.isBodyText) {
                        files = $scope.aux.files;
                        $scope.aux.body = '';
                    }

                    $scope.aux.datas.push({ key: 'title', value: $scope.aux.title });
                    $scope.aux.datas.push({ key: 'needsSignature', value: String($scope.aux.needsSignature) });
                    $scope.aux.datas.push({ key: 'sendMail', value: String($scope.aux.sendMail) });
                    $scope.aux.datas.push({ key: 'body', value: $scope.aux.body });

                    $scope.aux.files = [];
                    return adminAuthNotificationConfigService.create($scope.aux, files).then(function () {
                        $state.go('auth-notification-config-find');
                    }, function (error) {
                        $scope.aux.files = files;
                        errors.showError(error);
                    });
                };

                $scope.load();
            }
        ]);
})();